import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
    }

    toggle(e) {
        if(e.way === "enter") {
            if(this.$('video')[0].paused) {
                this.$('video')[0].play()
            }

        } else {
            if(!this.$('video')[0].paused) {
                this.$('video')[0].pause()
            }
        }
    }
}
